module.exports = __webpack_public_path__ + "a8a10a3e/img/comments-icon.fdec7fdb.svg";